var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFancyArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.1289,
    cy: 47.5552,
    r: 47,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8895 36.2634C34.566 34.3222 36.0629 32.5552 38.0308 32.5552V32.5552C38.5637 32.5552 39.088 32.6889 39.5558 32.944L61.9791 45.1749C63.2161 45.8497 63.9858 47.1462 63.9858 48.5552V48.5552C63.9858 49.9642 63.2161 51.2607 61.9791 51.9354L39.5558 64.1663C39.088 64.4215 38.5637 64.5552 38.0308 64.5552V64.5552C36.0629 64.5552 34.566 62.7881 34.8895 60.847L35.6022 56.5707C36.1533 53.2643 39.014 50.8409 42.3661 50.8409H50.2715C51.5338 50.8409 52.5572 49.8175 52.5572 48.5552V48.5552C52.5572 47.2928 51.5338 46.2695 50.2715 46.2695H42.3661C39.014 46.2695 36.1533 43.8461 35.6022 40.5396L34.8895 36.2634Z",
    fill: "#335443"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFancyArrow);
export default __webpack_public_path__ + "static/media/fancy-arrow.c20e471e40d32359b8e95698ee059bc2.svg";
export { ForwardRef as ReactComponent };